module.exports = __webpack_public_path__ + "static/2t-589785f8d4ce74885a5d2aa5e9e8445a.jpg";